import t from 'ember-intl/helpers/t';
import isArray from 'ember-truth-helpers/helpers/is-array';
import sortBy from '../helpers/sort-by';
import UserNameInfo from './user-name-info';
import UserStatus from './user-status';
import LoadingSpinner from './loading-spinner';
<template>
  <div class="leadership-list" data-test-leadership-list>
    <table class="ilios-table ilios-table-colors">
      <thead>
        <tr>
          {{#if @showDirectors}}
            <th>
              {{t "general.directors"}}
            </th>
          {{/if}}
          {{#if @showAdministrators}}
            <th>
              {{t "general.administrators"}}
            </th>
          {{/if}}
          {{#if @showStudentAdvisors}}
            <th>
              {{t "general.studentAdvisors"}}
            </th>
          {{/if}}
        </tr>
      </thead>
      <tbody>
        <tr>
          {{#if @showDirectors}}
            <td class="text-top" data-test-directors>
              <ul>
                {{#if (isArray @directors)}}
                  {{#each (sortBy "fullName" @directors) as |user|}}
                    <li>
                      <UserStatus @user={{user}} />
                      <UserNameInfo @user={{user}} />
                    </li>
                  {{else}}
                    <li>
                      {{t "general.none"}}
                    </li>
                  {{/each}}
                {{else}}
                  <LoadingSpinner />
                {{/if}}
              </ul>
            </td>
          {{/if}}
          {{#if @showAdministrators}}
            <td class="text-top" data-test-administrators>
              <ul>
                {{#if (isArray @administrators)}}
                  {{#each (sortBy "fullName" @administrators) as |user|}}
                    <li>
                      <UserStatus @user={{user}} />
                      <UserNameInfo @user={{user}} />
                    </li>
                  {{else}}
                    <li>
                      {{t "general.none"}}
                    </li>
                  {{/each}}
                {{else}}
                  <LoadingSpinner />
                {{/if}}
              </ul>
            </td>
          {{/if}}
          {{#if @showStudentAdvisors}}
            <td class="text-top" data-test-student-advisors>
              <ul>
                {{#if (isArray @studentAdvisors)}}
                  {{#each (sortBy "fullName" @studentAdvisors) as |user|}}
                    <li>
                      <UserStatus @user={{user}} />
                      <UserNameInfo @user={{user}} />
                    </li>
                  {{else}}
                    <li>
                      {{t "general.none"}}
                    </li>
                  {{/each}}
                {{else}}
                  <LoadingSpinner />
                {{/if}}
              </ul>
            </td>
          {{/if}}
        </tr>
      </tbody>
    </table>
  </div>
</template>
